export const normalizarCpfCnpj = (valor) => {
    if (!valor) return ''
    return valor.replace(/[./-]/g, '').toUpperCase()
}
